import { render } from "./AppFooter.vue?vue&type=template&id=5838ecba&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=5838ecba&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5838ecba"]])

export default __exports__